import * as Yup from 'yup';

export const notificationModalValidationSchema = Yup.object().shape({
    email: Yup.string().email('app.error.email').required('app.error.required'),
});
